import { getProductByLocation } from './store';

export const shouldBreakConfigLoop = (
  shootProducts,
  location,
  extraProducts = [],
) => {
  const product = getProductByLocation(shootProducts, location, extraProducts);
  const maxChildCount = product.maximum_children_count;
  const loc = location.pathname.split('/');
  const route = parseInt(loc[loc.length - 1]);

  // For You-Pick products, we need to check differently
  // The route number represents the current slot being configured (0-based)
  // We should only break when we've configured all required slots
  if (product.is_ypx || product.product_type === 'parent_product') {
    // You-Pick products: check if we've reached the maximum number of child products
    // Route 0 means configuring first product, route 1 means second, etc.
    // So we break when route >= maxChildCount (not when route > maxChildCount)
    return route >= maxChildCount;
  }

  // For regular products
  if (maxChildCount > route || !maxChildCount) return false;

  return true;
};

export const test = () => {
  console.log('test');
  return true;
};
